import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, defineMessages } from 'react-intl';
import s from './UserPopup.scss';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import xbutton from '../../MapHeader/img/x.png';

const mapStateToProps = (state) => ({
  messages: state.intl.messages,
  intl: state.intl.langKeys,
});

// const messages = defineMessages({
//   ustawienia: {
//     id: 'UserPopup.Settings',
//     defaultMessage: 'Ustawienia',
//     description: 'Ustawienia portalu',
//   },
// });
// <FormattedMessage {...messages["ustawienia"]} />

const UserPopup = (props) => {
  return (
    <div className={'navPopups col-sm-2 panel panel-primary absolute-popup'}>
      <div className={"panel-heading"}>{ props.isLoggedIn ? props.intl.zagolonawyJako + (props.username.email) : props.intl.niezalogowany}
        <img style={{float: "right"}} alt="X Button" className="xbutton" src={xbutton} onClick={props.onUserIconClick}/>
      </div>
      { props.isLoggedIn ? (
        <div className={"panel-body"}>
          <button className={'userPopupButton'} type={'submit'} onClick={props.logOutUser}>{props.intl.wyloguj}</button>
          {_.find(props.user.user.roles, o => o.nazwa === 'admin') ? (
            <button className={'userPopupButton'} type={'submit'} onClick={props.onShowModal}>{props.intl.ustawienia}</button>
          ) : null }

          {/*<div className="row" style={{ textAlign: "center" }}>
            <button type="button" className="btn btn-default" onClick={()=>props.changeLanguage('pl-PL')} >PL</button>
            <button type={"button"} className={"btn btn-default"} onClick={()=>props.changeLanguage('en-EN')}>EN</button>
            <button type="button" className="btn btn-default" onClick={()=>props.changeLanguage('de-DE')}>DE</button>
          </div>*/}
          <div className="row" style={{textAlign: "center"}}>
            <button type="button" className="btn btn-default" onClick={()=>props.changeSize('increase')}>A+</button>
            <button type="button" className="btn btn-default" onClick={()=>props.changeSize('decrease')}>A-</button>
          </div>
        </div>
      ) : (
        <div className={"panel-body"}>
          <button className={'userPopupButton'} type={'submit'} onClick={props.openLoginModal}>{props.intl.zaloguj}</button>
          <button className={'userPopupButton'} type={'submit'} onClick={props.openRegisterModal}>{props.intl.utwKonto}</button>
        </div>
      )}
    </div>
  );
};

UserPopup.PropTypes = {
  username: React.PropTypes.string,
  openLoginModal: React.PropTypes.func.isRequired,
  openRegisterModal: React.PropTypes.func.isRequired,
  changeLanguage: React.PropTypes.func.isRequired,
  changeSize: React.PropTypes.func.isRequired,
  isLoggedIn: React.PropTypes.bool.isRequired,
};

export default withStyles(s)(connect(mapStateToProps)(UserPopup));



// WEBPACK FOOTER //
// src/components/Modals/UserPopup/UserPopup.js